import { produce } from 'immer';

let initialState = {
  show: false,
  item: {},
  showConfirmation: false,
  position: {},
  feed: null,
  suggestions: [],
  getSuggestions: [],
  notificationSuggestions: [],
};

const updatePriceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_UPDATE_PANEL': {
      return {
        ...state,
        show: true,
        item: action.payload.item,
        unitsData: action.payload.unitsData,
        position: action.payload.position,
        feed: null,
      };
    }
    case 'HIDE_UPDATE_PANEL': {
      return { ...state, show: false, item: {} };
    }
    case 'HIDE_CONFIRMATION': {
      return Object.assign({}, state, { showConfirmation: false });
    }
    case 'SHOW_CONFIRMATION': {
      return Object.assign({}, state, {
        item: action.payload.item,
        unitsData: action.payload.unitsData,
        showConfirmation: true,
      });
    }
    case 'UPDATE_FEED': {
      return Object.assign({}, state, { feed: action.payload.feed });
    }
    case 'GET_SUGGESTIONS': {
      const { suggestions } = action.payload;

      return produce(state, (draft) => {
        draft.getSuggestions = suggestions;
        draft.suggestions = suggestions;
        draft.isLoading = false;
      });
    }

    case 'UPDATE_SUGGESTIONS': {
      const { suggestions } = action.payload;

      return produce(state, (draft) => {
        const suggestionsMap = new Map(
          suggestions.map((item) => [item.id, item])
        );

        const updatedSuggestions = state.suggestions.map((item) => {
          const id = parseInt(item.id);
          return suggestionsMap.has(id) ? suggestionsMap.get(id) : item;
        });

        const newSuggestions = suggestions.filter(
          (item) =>
            !state.suggestions.some(
              (existing) => parseInt(existing.id) === parseInt(item.id)
            )
        );

        draft.notificationSuggestions = suggestions;
        draft.suggestions = [...updatedSuggestions, ...newSuggestions];
        draft.isLoading = false;
      });
    }

    case 'SUGGEST_PRICE': {
      const { payload: suggestion } = action;
      return produce(state, (draft) => {
        draft.suggestions.push(suggestion);
        draft.isLoading = false;
      });
    }

    case 'APPROVE_SUGGESTION': {
      const { payload: suggestion } = action;
      return produce(state, (draft) => {
        const index = draft.suggestions.findIndex(
          (_suggestion) => parseInt(_suggestion.id) === parseInt(suggestion.id)
        );
        if (index !== -1) {
          draft.suggestions[index] = suggestion;
        }
        draft.isLoading = false;
      });
    }

    case 'UPDATE_COMPETITOR_DATA': {
      return Object.assign({}, state, {
        competitorData: action.payload.competitorData,
      });
    }
    case 'LOGOUT': {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
export default updatePriceReducer;
